export default __webpack_public_path__ + "static/media/sharjah.478986cf.jpg";